import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const office = require('../images/office.jpg');

export const Contact = () => {
  return (
    <Container fluid className="content">
      <Row>
        <Col className="title">
          <h1>Contact Us</h1>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={6} lg={4} className="image-column">
          <img src={office} alt="Dr. Madsen's Office" />
          <h2>
            Erik Madsen
            <br />
            D.D.S., M.S.
          </h2>
          11996 S Anthem Park Blvd
          <br />
          Suite # 101
          <br />
          Herriman, UT 84096
          <br />
          <strong>Phone:</strong> <a href="tel:801-943-2700">(801)943-2700</a>
          <br />
          <strong>E-mail:</strong>{' '}
          <a href="mailto:reception@brightersmilesbraces.com?subject=Web%20Inquiry">
            reception@brightersmilesbraces.com
          </a>
          <br />
          <strong>Fax:</strong> (801)495-2771
          <br />
          <br />
        </Col>
        <Col sm={12} md={4} lg={6}>
          <iframe
            title="Map Directions"
            src="https://www.google.com/maps/d/u/0/embed?mid=1U_guvN0DPg4LHAXH9z--IcGP7-Q&ehbc=2E312F"
            width="100%"
            height="400px"
          />
          <small>
            View{' '}
            <a href="https://www.google.com/maps/d/u/0/embed?mid=1U_guvN0DPg4LHAXH9z--IcGP7-Q&ehbc=2E312F">
              Erik Madsen, D.D.S., M.S.
            </a>{' '}
            in a larger map
          </small>
          <br />
        </Col>
      </Row>
      <Row>
        <Col>
          <br />
          <br />
        </Col>
      </Row>
    </Container>
  );
};
